import client from 'src/api/apollo/client';
import { COMPANY_AND_WORTH_UPDATE } from 'src/api/graphql/mutations/companyAndWorth.gql';
import { createGraphqlRequestError } from 'src/utils/helpers/getGraphqlErrorMessage';

export const updateCompanyAndWorth = async (
	companyId,
	{ companyInput, worthInput },
) => {
	try {
		const { data } = await client.mutate({
			mutation: COMPANY_AND_WORTH_UPDATE,
			variables: {
				id: String(companyId),
				companyInput,
				worthInput,
			},
		});

		return {
			company: data.company.company,
			worth: data.worth.worth,
		};
	} catch (error) {
		throw createGraphqlRequestError(error, 'Не удалось изменить ценность');
	}
};
